module.exports = __webpack_public_path__ + "img/startConfigurationAttachmentSetting@2x.1f1829f.webp";